import { Link } from "react-router-dom";

export default function MathDrillsHome(){

return(

<div className="min-h-screen bg-[#FAF6EF] flex flex-col items-center justify-center">

<h1 className="text-4xl font-bold mb-6 text-[#3A2A1A]">
Math Drills
</h1>

<p className="mb-10 text-[#5C4632]">
Sharpen your brain with daily math exercises
</p>

<div className="grid grid-cols-1 md:grid-cols-2 gap-10">

<div className="bg-[#F4EBDD] p-10 rounded-xl shadow text-center">

<h2 className="text-xl mb-3">Chain Math</h2>

<Link to="/math-drills/chain-math"
className="inline-block bg-[#7A4A28] text-white px-6 py-3 rounded-lg">
Start →
</Link>

</div>

<div className="bg-[#F4EBDD] p-10 rounded-xl shadow text-center">

<h2 className="text-xl mb-3">Mental Math</h2>

<Link to="/math-drills/mental-math"
className="inline-block bg-[#7A4A28] text-white px-6 py-3 rounded-lg">
Start →
</Link>

</div>

</div>

</div>

)
}
